// Fulfillment KPI dashboard (Asana 1219612776200513): display helpers.

// Load state of one part of the page, kept in place of its data
export const LOAD_STATE = { LOADING: "loading", FAILED: "failed" };
export const isLoaded = (value) =>
  value !== LOAD_STATE.LOADING && value !== LOAD_STATE.FAILED;

const MONTH_PATTERN = /^(\d{4})-(\d{2})$/;

// fixed abbreviations: Intl gives "Mär" or "März" depending on the ICU data
const MONTH_NAMES = {
  de: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  en: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};

// "2025-10" -> "Okt 2025" / "Oct 2025"
export const formatMonthLabel = (month, language = "de") => {
  const match = MONTH_PATTERN.exec(month || "");
  if (!match) return month || "";
  const names = MONTH_NAMES[language] || MONTH_NAMES.de;
  return `${names[Number(match[2]) - 1]} ${match[1]}`;
};

// 33.3 -> "33,3 %" (de) / "33.3 %" (en); null -> "–"
export const formatPercent = (value, language = "de") =>
  value === null || value === undefined
    ? "–"
    : `${new Intl.NumberFormat(language, { maximumFractionDigits: 1 }).format(
        value
      )} %`;

// newest month that is complete and has a value (shown in the tiles)
export const lastCompleteRow = (rows = [], key) =>
  [...rows]
    .reverse()
    .find(
      (row) => row.complete && row[key] !== null && row[key] !== undefined
    ) || null;

// HubSpot date "2026-09-30" -> "30.09.2026"
export const formatHubspotDay = (day) =>
  /^\d{4}-\d{2}-\d{2}$/.test(day || "")
    ? day.split("-").reverse().join(".")
    : "";

// bar values per month; a running month gets the lighter color
export const toBarSeries = (rows = [], key, color, runningColor) =>
  rows.map((row) => ({
    x: row.month,
    // no value (no decided customers yet) stays a gap, not a 0 % bar
    y: row[key] ?? null,
    fillColor: row.complete ? color : runningColor,
    running: !row.complete
  }));
